import { merge } from 'lodash'

import { ApiHandleParams } from '@service/api'
import { debounce } from '@utils'

export default {
  props: {
    api: { required: true },
    handle: { default: () => new ApiHandleParams() },
    useCacheItems: Boolean,
  },
  data: () => ({}),
  computed: {},
  watch: {},
  methods: {
    reload: debounce(function({ forceToPage1 } = { forceToPage1 }) {
      this.cache.clear()
      this.c_items = []
      if (!this.showPagination || forceToPage1) {
        this.p_pagination.page = 1
      }
      this.updateItems()
    }, 200),
    onUpdateFilters(filters) {
      this.c_filters = filters
      this.reload()
    },
    onUpdatePage(page) {
      this.p_pagination.page = page || 1
      this.updateItems()
    },
    onUpdatePerPage(perpage) {
      this.p_pagination.itemsPerPage = perpage
      this.reload({ forceToPage1: true })
    },
    onUpdateOrderBys(orderBys) {
      this.c_orderBys = orderBys
      this.reload()
    },
    onUpdateOption({ filters, orderBys, pagination } = {}) {
      if (filters) {
        this.handle.setFilters(filters)
        this.p_filters = this.handle.getFilters()
      }
      if (orderBys) {
        this.handle.setOrderBys(orderBys)
        this.p_orderBys = this.handle.getOrderBys()
      }
      if (pagination) {
        this.handle.updatePagination(pagination)
        this.p_pagination = this.handle.getPagination()
      }
      this.c_options = this.handle.getOption()
    },
    getParams() {
      if (this.isPagination) this.handle.isPaginate()
      return {
        ...this.handle.convertParam({
          filters: this.c_filters,
          orderBys: this.c_orderBys,
          pagination: this.c_pagination,
        }),
        ...this.c_params,
      }
    },
    onLoadMore() {
      if (this.c_loading) return
      if (
        !this.c_pagination.hasMoreItems ||
        this.c_pagination.total == this.c_items.length
      )
        return
      this.p_pagination.page = this.c_pagination.page + 1
      this.updateItems()
    },
    getData(params) {
      if (!this.api) return
      this.c_loading = true
      this.c_pagination.isError = false
      params = merge({},this.defaultParams, this.getParams(), params)
      this.setParamsToQueryUrl(params)
      this.api
        .list(params)
        .then((res) => {
          if (res.error) {
            this.$set(this.p_pagination, 'isError', true)
            return
          }
          const { data } = res
          let { items, pagination } = this.handle.convertData(data)
          this.c_pagination = pagination
          this.cache.addItem(items, this.c_pagination)
          if (pagination.total > 0 || pagination.hasMoreItems)
            this.updateItems()
        })
        .finally(() => {
          this.c_loading = false
        })
    },
    updateItems() {
      let page = this.c_pagination.page
      let items = this.cache.getItem(page)
      if (!items || items.length < 1) {
        this.getData({ page })
        return
      }
      this.setParamsToQueryUrl()
      if (this.showPagination) {
        this.c_items = items
      } else {
        this.c_items = this.cache.getItemArray(1, this.c_pagination.page)
      }
    },
  },
}
